/**
 * Financiación de la colección de pozos desde el admin: UNA autoridad para los
 * juegos que la usan (Lotowheel y Digi 12). El backend deriva importes y total
 * (`/coleccion/preview`); aquí solo se confirma lo que el operador vio y se
 * envía con una key propia por intento, que el backend deduplica.
 */

import { App, Api } from '../../../admin.js';
import { t } from '../../../services/i18n-admin.js';

/** El plan que el backend deriva para esos pozos, o null si no lo pudo armar. */
export async function pedirPreviewDeFinanciacion(pozoIds) {
    const datos = await Api.callAdmin(`/admin/pozos-comunes/coleccion/preview?pozoIds=${pozoIds.join(',')}`, 'GET');
    return datos && datos.ok ? datos : null;
}

/**
 * Confirma el total del preview y financia las cuatro semillas activando la
 * colección. Devuelve la respuesta del backend, o null si el operador canceló.
 */
export async function confirmarYFinanciarColeccion({ gameTypeCode, sorteoId, preview }) {
    const totalLegible = App.formatMoney(preview.totalCentimos, preview.moneda);
    if (!confirm(t('Se registrará la financiación inicial de los cuatro acumulados por ') + totalLegible + '.')) {
        return null;
    }
    const resultado = await Api.callAdmin('/admin/pozos-comunes/coleccion/financiar', 'POST', {
        gameTypeCode,
        sorteoId,
        pozoIds: preview.semillas.map(s => s.pozoId),
        totalEsperadoCentimos: preview.totalCentimos,
        idempotencyKey: `semilla:${gameTypeCode}:${sorteoId}:${crypto.randomUUID()}`,
    });
    if (resultado && resultado.ok) App.toast(t('Colección financiada y activada por ') + totalLegible);
    return resultado;
}
